import React, { useState } from 'react';
import { Grid, Box, Stack, Button, Tab } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';

import HRNavbar from '../HRNavbar';
import Footer from '../../../Footer';
import ExistManpower from './ExistManpower';
import NewManpower from './NewManpower';
import Interview from './Interview';
import Employee from './Employee';
import InactiveEmp from './InactiveEmp';
import Map from './Map';
import Onboarding from './Onboarding';
import ProfAvailable from './ProfAvailable';

const HRDashboard = () => {
    // Permission logic
    const permissions = JSON.parse(localStorage.getItem('permissions')) || [];
    const isDownload = permissions.some(permission =>
        permission.modules_submodule.some(module => {
            if (module.submodules && module.submodules.length > 0) {
                return module.submodules.some(sub => sub.submodule_name === 'Download');
            }
            if (module.modules && module.modules.length > 0) {
                return module.modules.some(submodule =>
                    submodule.submodules && submodule.submodules.some(sub => sub.submodule_name === 'Download')
                );
            }
            return false;
        })
    );

    const [value, setValue] = useState('1');

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    // Helper component to avoid repeating the grid for each tab
    const DashboardGrid = ({ filterValue }) => (
        <Box sx={{ px: 1 }}> {/* Horizontal padding for better spacing */}
            <Grid container spacing={1.5}>
                <Grid item lg={3} md={6} sm={12} xs={12}>
                    <ExistManpower value={filterValue} />
                </Grid>
                <Grid item lg={3} md={6} sm={12} xs={12}>
                    <ProfAvailable value={filterValue} />
                </Grid>
                <Grid item lg={3} md={6} sm={12} xs={12}>
                    <NewManpower value={filterValue} />
                </Grid>
                <Grid item lg={3} md={6} sm={12} xs={12}>
                    <Interview value={filterValue} />
                </Grid>

                <Grid item lg={3} md={6} sm={12} xs={12}>
                    <Employee value={filterValue} />
                </Grid>
                <Grid item lg={3} md={6} sm={12} xs={12}>
                    <InactiveEmp value={filterValue} />
                </Grid>
                <Grid item lg={3} md={6} sm={12} xs={12}>
                    <Map value={filterValue} />
                </Grid>
                <Grid item lg={3} md={6} sm={12} xs={12}>
                    <Onboarding value={filterValue} />
                </Grid>
            </Grid>
        </Box>
    );

    return (
        <>
            <HRNavbar />
            <Box sx={{ flexGrow: 1, width: "100%", bgcolor: "#f5f7f9", minHeight: "85vh", pb: 4 }}>
                <TabContext value={value}>
                    <Stack 
                        direction={{ xs: 'column', sm: 'row' }} 
                        justifyContent="space-between" 
                        alignItems="center" 
                        spacing={2} 
                        sx={{ p: 2 }}
                    >
                        {/* <Box sx={{
                            background: "#FFFFFF",
                            borderRadius: '10px',
                            width: { xs: "100%", sm: "22rem" },
                            height: "2.8rem",
                            display: 'flex',
                            justifyContent: 'center',
                            boxShadow: "0px 2px 4px rgba(0,0,0,0.05)"
                        }}>
                            <TabList
                                onChange={handleChange}
                                textColor="primary"
                                TabIndicatorProps={{ style: { background: '#69A5EB', height: '36px', marginBottom: '4px', borderRadius: "8px" } }}
                                sx={{ minHeight: "40px" }}
                            >
                                <Tab label={<span style={{ fontSize: '14px', textTransform: "capitalize", color: value === "1" ? '#ffffff' : '#333', fontWeight: 600 }}>Today</span>} value="1" sx={{ zIndex: 1, minHeight: "40px" }} />
                                <Tab label={<span style={{ fontSize: '14px', textTransform: "capitalize", color: value === "2" ? '#ffffff' : '#333', fontWeight: 600 }}>This Week</span>} value="2" sx={{ zIndex: 1, minHeight: "40px" }} />
                                <Tab label={<span style={{ fontSize: '14px', textTransform: "capitalize", color: value === "3" ? '#ffffff' : '#333', fontWeight: 600 }}>This Month</span>} value="3" sx={{ zIndex: 1, minHeight: "40px" }} />
                            </TabList>
                        </Box> */}

                        {isDownload && (
                            <Button 
                                variant="contained" 
                                startIcon={<FileDownloadOutlinedIcon />}
                                sx={{ 
                                    backgroundColor: "#69A5EB", 
                                    textTransform: "capitalize", 
                                    borderRadius: "8px", 
                                    height: "40px",
                                    '&:hover': { backgroundColor: "#5694d6" } 
                                }}
                            >
                                Download Report
                            </Button>
                        )}
                    </Stack>

                    <Box sx={{ width: '100%', typography: 'body1' }}>
                        <TabPanel value="1" sx={{ p: 0 }}>
                            <DashboardGrid filterValue={1} />
                        </TabPanel>
                        <TabPanel value="2" sx={{ p: 0 }}>
                            <DashboardGrid filterValue={2} />
                        </TabPanel>
                        <TabPanel value="3" sx={{ p: 0 }}>
                            <DashboardGrid filterValue={3} />
                        </TabPanel>
                    </Box>
                </TabContext>
            </Box>
            <Footer />
        </>
    );
}

export default HRDashboard;